import { render } from "./addressForm.vue?vue&type=template&id=9b5b54a4&scoped=true&ts=true"
import script from "./addressForm.vue?vue&type=script&lang=ts"
export * from "./addressForm.vue?vue&type=script&lang=ts"

import "./addressForm.vue?vue&type=style&index=0&id=9b5b54a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b5b54a4"]])

export default __exports__